import React from 'react';

import {Box, Paper, Skeleton, Stack} from 'views/components';

const KeyMetricsSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', md: 'repeat(3, minmax(0, 1fr))'},
        gap: 1.75,
      }}
    >
      {
        Array.from({length: 3}).map((x, index) => {
          return (
            <Paper
              key={index}
              sx={{
                p: 2.5,
                borderRadius: '8px',
                border: '1px solid #E5E5E5',
                boxShadow: 'none',
              }}
            >
              <Stack spacing={1.5}>
                <Stack direction='row' justifyContent='space-between' alignItems='flex-start' spacing={2}>
                  <Box sx={{flex: 1, minWidth: 0}}>
                    <Skeleton variant='text' width='45%' height={20} />
                    <Skeleton variant='text' width='30%' height={42} />
                  </Box>
                  <Skeleton variant='rounded' width={96} height={32} />
                </Stack>
                <Box sx={{borderTop: '1px solid #EAEAEA'}} />
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                  <Skeleton variant='rounded' width={64} height={22} />
                  <Skeleton variant='text' width='32%' height={18} />
                </Stack>
              </Stack>
            </Paper>
          );
        })
      }
    </Box>
  );
};

export default React.memo(KeyMetricsSkeleton);
